/* Transformation Timeline — custom section behavior.
   Marks each entry reached as it crosses the lower third of the viewport;
   the CSS draws the spine segment and fades the entry in. Reached states
   persist (time only moves forward). Reduced-motion users get the fully
   drawn spine from CSS alone. */

if (!window.customElements.get('transformation-timeline')) {
  class TransformationTimeline extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-tt-item]'));

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.items.forEach((item) => item.classList.add('is-reached'));
        return;
      }

      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-reached');
              this.io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -30% 0px' }
      );

      this.items.forEach((item) => this.io.observe(item));
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  window.customElements.define('transformation-timeline', TransformationTimeline);
}
